import { createFeatureSelector, createSelector } from '@ngrx/store';
import { substituteFeatureKey, SubstituteState } from './substitute.reducer';

export const selectSubstituteState = createFeatureSelector<SubstituteState>(
  substituteFeatureKey
);

export const selectSubstitutes = createSelector(
  selectSubstituteState,
  (state) => state.data
);

export const selectSubstitutesLoaded = createSelector(
  selectSubstituteState,
  (state) => state.loaded
);

export const selectSubstitutesLoading = createSelector(
  selectSubstituteState,
  (state) => state.loading
);

export const selectSubstitutesScope = createSelector(
  selectSubstituteState,
  (state) => state.scope
);
